import { render, staticRenderFns } from "./RelativeRelationTypes.vue?vue&type=template&id=25557ae0&"
import script from "./RelativeRelationTypes.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports